import {createStrokeSVG} from './TEMPLATE'

// tabler: repeat
export const RepostRepost_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3',
    'M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: repeat
export const Repost_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3',
    'M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: repeat
export const Repost_Stroke2_Corner3_Rounded = createStrokeSVG({
  paths: [
    'M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3',
    'M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
